// extracted by mini-css-extract-plugin
module.exports =  {"productsTable":"productsTable__Tj2K2","productsTableHeader":"productsTableHeader__9uXro","productsTableBody":"productsTableBody__uiMEt"};